import React from 'react'

function FooterProperties() {
  return (
    <div>
        <footer>
    <div className="container">
      <div className="col-lg-12">
        <p>Copyright © 2048 Villa Agency Co., Ltd. All rights reserved. 
        
        Design: <a rel="nofollow" href="https://templatemo.com" target="_blank">TemplateMo</a></p>
      </div>
    </div>
  </footer>
    </div>
  )
}

export default FooterProperties